import type { IntegrationSectionType, IVendorMapping } from '@xilo-mono/integration-contracts';
import { IFormFontSettings } from '../constants/theme.const';
import { IPipeline } from './pipeline.model';
import { Lifecycle } from './lifecycle.model';

export class Company {
  constructor(
    public id?: number,
    public name?: string,
    public slogan?: string,
    public city?: string,
    public state?: string,
    public contactNumber?: string,
    public contactEmail?: string,
    public mainLocation?: string,
    public logo?: string,
    public customerId?: string,
    public cardId?: string,
    public addedPayment?: boolean,
    public agents?: any,
    public hasActiveSubscription?: boolean,
    public companyId?: string,
    public companyWebsite?: string,
    public navbarBackgroundColorStart?: string,
    public navbarBackgroundColorEnd?: string,
    public navbarFontColor?: string,
    public emailText?: string,
    public navbarFont?: string,
    public resetPasswordLink?: string,
    public facebookApiKey?: string,
    public klaviyoApiKey?: string,
    public redirectCompany?: boolean,
    public redirectUrl?: string,
    public brandColor?: string,
    public hasAppliedEpic?: boolean,
    public hasEzlynx?: boolean,
    public pipedriveIntegration?: boolean,
    public pipedriveToken?: string,
    public pipedriveUrl?: string,
    public pipedriveStage?: string,
    public pipedriveStageId?: string,
    public pipedrivePipeline?: string,
    public pipedrivePipelineId?: string,
    public fireFirstEmailAuto?: boolean,
    public fireSecondEmailAuto?: boolean,
    public hasGoogleConversions?: boolean,
    public googleAdwordsCustomerId?: string,
    public googleAnalyticsViewId?: string,
    public googleApiAccessToken?: string,
    public googleApiRefreshToken?: string,
    public logoHeight?: string,
    public hasSalesforce?: boolean,
    public hasZapier?: boolean,
    public accessToken?: string,
    public headerText?: string,
    public subHeaderText?: string,
    public placeholderText?: string,
    public secondaryPlaceholderText?: string,
    public buttonText?: string,
    public textNumber?: string,
    public ezlynxRqUid?: string,
    public hasEzlynxIntegration?: boolean,
    public hasInfusionsoftIntegration?: boolean,
    public hasQQIntegration?: boolean,
    public listClientDetailsOnEmail?: boolean,
    public updatedAt?: Date,
    public createdAt?: Date,
    public platformManagerCompanyId?: number,
    public hubspotApiKey?: string,
    public hubspotIntegration?: boolean,
    public hasUSDotIntegration?: boolean,
    public hasSalesAutomation?: boolean,
    public infusionsoftApiAccessToken?: string,
    public hasGoogleEvents?: boolean,
    public googleAnalyticsId?: string,
    public hasQuoteRushIntegration?: boolean,
    public hasTurboraterIntegration?: boolean,
    public hasNowCertsIntegration?: boolean,
    public hasWealthboxIntegration?: boolean,
    public hasAMS360Integration?: boolean,
    public hasV2Integrations?: boolean,
    public brandSecondaryColor?: string,
    public gaCrossDomainURL?: string,
    public brandingURL?: string,
    public formGroups?: string[],
    public features?: any,
    public signupDetails?: any,
    public signupStatus?: string,
    public urlPath?: string,
    public selectionPageHeaderText?: string,
    public selectionPageSubHeaderText?: string,
    public selectionPageLabel?: string,
    public form_font_settings?: IFormFontSettings,
    public data?: any,
    public children?: Company[],
    public pipelines?: IPipeline[],
    public lifecycles?: Lifecycle[]
  ) {}
}

export interface UpdateFormGroupPayload {
  type: 'create' | 'edit' | 'delete';
  newFormGroupName?: string;
  oldFormGroupName?: string;
}

export interface UpdateFeatureFlag {
  feature: string;
  role: string;
  value: boolean;
}

export interface Referral {
  id?: number;
  name: string;
  contact?: Contact;
  referredByList?: string[];
}
export interface Contact {
  email: string;
  phone: string;
  last_name: string;
  first_name: string;
}

export interface IntegrationMap {
  id: number;
  jsonMapping?: IVendorMapping[];
  vendorId: number;
  formId: string;
  isActive: boolean;
  isDataPull: boolean;
  order: number;
  createdAt: string;
  updatedAt: string;
  vendor: Vendor;
  name?: string;
}
export interface Vendor {
  id: number;
  name: string;
  schema?: SchemaEntity[] | null;
  icon: string;
  description: string;
  isActive: boolean;
  type: string;
  organization: string;
  isDataPull: boolean;
  isFileDownload: boolean;
  createdAt: string;
  updatedAt: string;
}
export interface SchemaEntity {
  key: string;
  label: string;
  typeDefinition: TypeDefinition;
  hideDescendants?: boolean;
}
export interface TypeDefinition {
  type: IntegrationSectionType;
  isRequired?: boolean | null;
  properties: any;
}

export interface IntegrationJob {
  success: boolean;
  status: boolean;
  log?: IntegrationLog;
}
export interface IntegrationLog {
  submissionId: any;
  jsonDataIn: any;
  missingFields: string[];
  id: string;
  result: string;
  validationErrors?: null[] | null;
  jobId: string;
  vendorLink: string;
  vendorName: string;
  vendorResponse?: string;
}
